import React from "react";
import { useLivePrice } from "@/context/LivePriceContext";

/**
 * Global AONE/USDT live-price ticker. Sits under the top nav on every page.
 * Rotates every 100ms with ±2% band random walk.
 */
export default function LivePriceTicker() {
    const { price, prev, changePct } = useLivePrice();
    const up = price >= prev;
    return (
        <div
            className="border-b"
            style={{ borderColor: "var(--border)", background: "var(--bg-raised)" }}
            data-testid="live-price-ticker"
        >
            <div className="max-w-[1440px] mx-auto px-5 sm:px-8 py-2 flex items-center gap-4 flex-wrap text-[11.5px]">
                <div className="flex items-center gap-2">
                    <span className="relative flex h-2 w-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75" style={{ background: "var(--success)" }} />
                        <span className="relative inline-flex rounded-full h-2 w-2" style={{ background: "var(--success)" }} />
                    </span>
                    <span className="font-mono uppercase tracking-[0.14em] text-[10px] text-[var(--success)] font-medium">
                        Aegis Mainnet · Live
                    </span>
                </div>

                <div className="hidden sm:flex items-center gap-2">
                    <span className="text-[var(--text-3)] font-mono uppercase tracking-[0.12em] text-[10px]">AONE / USDT</span>
                    <span
                        data-testid="live-price-value"
                        className={`font-mono font-semibold tabular-nums transition-colors ${up ? "text-[var(--success)]" : "text-[var(--danger)]"}`}
                    >
                        ${price.toFixed(7)}
                    </span>
                    <span className={`font-mono text-[10.5px] tabular-nums ${changePct >= 0 ? "text-[var(--success)]" : "text-[var(--danger)]"}`}>
                        {changePct >= 0 ? "+" : ""}{changePct.toFixed(2)}%
                    </span>
                </div>

                <div className="hidden md:flex items-center gap-2 text-[var(--text-3)] font-mono text-[10px] uppercase tracking-[0.12em]">
                    <span>· Auto-Pool</span>
                    <span className="text-[var(--success)]">Healthy</span>
                </div>

                <div className="ml-auto flex items-center gap-2 text-[var(--text-3)] font-mono text-[10px] uppercase tracking-[0.12em]">
                    <span>Chain ID</span>
                    <span className="text-[var(--text-2)]">aegis-1</span>
                </div>
            </div>
        </div>
    );
}
